import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import ProviderNetworkTypeBadge from "@app/shared/ProviderNetworkTypeBadge";
import { sortProviderNetworkTypes } from "@app/shared/enums/providerNetworkTypeEnum";
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";
import formatPhoneNumber from "@app/shared/formatPhoneNumber";
import { NO_ACTIONS_APPLIED_LABEL } from "@app/projects/network-assessment/provider-hub/utility";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";

export const OrganizationProfileOverview: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const projectContext = useContext(CountyProjectContext);
  const { selectedOrganization } = providerHubContext;

  return (
    <Accordion title="Overview" testId="provider-profile__overview-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row--source">
          <dt className="provider-profile__overview-label--source">Primary NPI (Type 2)</dt>
          <dd className="provider-profile__overview-value">{selectedOrganization?.npi || "---"}</dd>
        </div>
        <div className="provider-profile__overview-row--source">
          <dt className="provider-profile__overview-label--source">Provider Source</dt>
          <dd className="provider-profile__overview-value">
            {sortProviderNetworkTypes(selectedOrganization.providerNetworkTypes ?? []).map((pt) => (
              <ProviderNetworkTypeBadge badgeStyle={ProviderBadgeStyle.Outline} providerNetworkType={pt} key={pt} />
            ))}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label--status">Status</dt>
          <dd className="provider-profile__overview-value--status">
            {(selectedOrganization.providerActionStatuses ?? []).length > 0 ? (
              selectedOrganization.providerActionStatuses.map((item) => (
                <ol key={item}>
                  <li><ProviderActionStatusBadge badgeStyle={ProviderBadgeStyle.Dot} status={item} /></li>
                </ol>
              ))
            ) : (
              NO_ACTIONS_APPLIED_LABEL
            )}
          </dd>
        </div>

        { projectContext.project.showPciData && <>
            <div className="provider-profile__overview-row">
              <dt className="provider-profile__overview-label">Average Quality (Effectiveness) Score</dt>
              <dd className="provider-profile__overview-value">
                {selectedOrganization.quality ?? "---"}/5.0
              </dd>
            </div>

            <div className="provider-profile__overview-row">
              <dt className="provider-profile__overview-label">Average Cost (Efficiency) Score</dt>
              <dd className="provider-profile__overview-value">
                {selectedOrganization.cost ?? "---"}/5.0
              </dd>
            </div>
          </>
        }

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">DBA Name</dt>
          <dd className="provider-profile__overview-value">
            {selectedOrganization.dbaName ?? "---"}
          </dd>
        </div>
        <RoleRestricted allowedRoles={[Roles.TIN_VIEWER]}>
          <div className="provider-profile__overview-row">
            <dt className="provider-profile__overview-label">TIN</dt>
            <dd className="provider-profile__overview-value">
              {selectedOrganization.tin || "---"}
            </dd>
          </div>
        </RoleRestricted>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Phone Number</dt>
          <dd className="provider-profile__overview-value">
            {formatPhoneNumber(selectedOrganization.phoneNumber)}
          </dd>
        </div>
      </dl>
    </Accordion>
  )
};